/**
 * How far back the performance console reads, and the windows its picker
 * offers.
 *
 * Both pages hold a window of their own — the overview and one metric's
 * detail — and neither produces the vocabulary: it is the server's enum, and
 * which of its members are worth offering is a decision about the control
 * rather than about either page. So it is made once here and read by both.
 *//**
 * How far back a reading looks. Mirrors the server's TelemetryWindow; the
 * widest is the retention horizon, so nothing older exists to ask for.
 *//**
 * The windows the picker offers, widest last, with how to label each.
 *
 * Relay generates the type and not a list, so this is the one place the
 * windows are written out — and each is checked against the generated union,
 * so a window the server renames or retires fails here rather than at a
 * request. A window the server adds type-checks without being listed, so it
 * has to be added here too.
 */export const WINDOW_OPTIONS=[{value:"LAST_HOUR",label:"1h"},{value:"LAST_24_HOURS",label:"24h"},{value:"LAST_3_DAYS",label:"3d"},{value:"LAST_7_DAYS",label:"7d"},{value:"LAST_14_DAYS",label:"14d"}];